import axios from 'axios';
import { mutate } from 'swr';

import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';

import { Notistack } from '@shared/components/Notistack/Notistack';
import { TLenderCreditRule } from '../../interfaces';

const processYellowValue = (value?: number) => (value ? `${value}` : undefined);

const BASE_URL = `/${SERVICES.LENDER}/lenders/`;

export const requestCreateCreditRule = (lenderId: string, creditRule: TLenderCreditRule) => {
  const path = `${BASE_URL}${lenderId}/lenderCreditRule`;
  return mutate(`${BASE_URL}${lenderId}`, async() => {
    try {
      await axios.put(path, {
        ...creditRule,
        value: `${creditRule.value}`,
        yellowValue: processYellowValue(creditRule.yellowValue),
        id: undefined,
      });
      Notistack.successMessage('CreditRule - Created Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestUpdateCreditRule = (lenderId: string, creditRule: TLenderCreditRule) => {
  const path = `${BASE_URL}${lenderId}/lenderCreditRule/${creditRule.id}`;
  return mutate(`${BASE_URL}${lenderId}`, async() => {
    try {
      await axios.patch(path, {
        ...creditRule,
        value: `${creditRule.value}`,
        yellowValue: processYellowValue(creditRule.yellowValue),
      });
      Notistack.successMessage('CreditRule - Updated Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestDeleteCreditRule = (lenderId: string, creditRuleId = '') => {
  const path = `${BASE_URL}${lenderId}/lenderCreditRule/${creditRuleId}`;
  return mutate(`${BASE_URL}${lenderId}`, async() => {
    try {
      await axios.delete(path);
      Notistack.successMessage('CreditRule - Deleted Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};
